/**
 * External dependencies
 */
import { render } from '@wordpress/element';

/**
 * Internal dependencies
 */
import BookingContainer from '../../components/event-table/container';
import { decodeAttributesFor } from '../../includes/misc-utils';

const bookingsContainersHTML = document.getElementsByClassName( 'wc-bookings-availability-main-events-container' );

for ( const bookingsContainerHTML of bookingsContainersHTML ) {
	const attributes = decodeAttributesFor( 'schedule', bookingsContainerHTML.dataset );
	render( <BookingContainer { ...attributes } />, bookingsContainerHTML );
}
